export const setLocalStorageItem = (key, value) => {
	try {
		const serializedValue = JSON.stringify(value);
		localStorage.setItem(key, serializedValue);
	} catch (error) {
		console.error('Error saving to localStorage', error);
	}
};

export const getLocalStorageItem = (key) => {
	
	if (typeof window !== 'undefined' && window.localStorage) {
		try {
			const value = window.localStorage.getItem(key);
			if (value) {
				return value;
			}
		} catch (error) {
			console.error(`Error reading ${key} from localStorage:`, error);
		}
	} 
	return null; 
  };

export const removeLocalStorageItem = (key) => {
	try {
		localStorage.removeItem(key);
	} catch (error) {
		console.error('Error removing from localStorage', error);
	}
};

export const setCookie = (name, value, days = 2) => {
	try {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		document.cookie = `${name}=${encodeURIComponent(value)}; path=/; expires=${date.toUTCString()}; secure; samesite=strict`;
	} catch (error) {
		console.error('Error setting cookie', error);
	}
};

export const getCookie = (name) => {
	try {
		if (typeof document !== 'undefined') {
			const value = `; ${document.cookie}`;
			const parts = value.split(`; ${name}=`);
			if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
		}
	} catch (error) {
		console.error('Error getting cookie', error);
	}
	return null;
};
